import * as types from "../actions/ActionTypes";

const initialState = {
  queuesList: [],
  queueDropdownList: [],
  queueRecord: null,
  redirectToList: false,
  validation_error: null,
  showUpdateForm: false,
  showViewPage: false,
  formState: {},
};

const QueueReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.QUEUES_REQUEST:
      return { ...state, redirectToList: false, validation_error: null };

    case types.QUEUES_SUCCESS:
      return {
        ...state,
        queuesList: action.queuesList,
      };

    case types.QUEUES_DROPDOWN_SUCCESS:
      return { ...state, queueDropdownList: action.queueDropdownList };

    case types.QUEUES_GET_SUCCESS:
      return {
        ...state,
        queueRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showUpdateForm: action.actionType === "update",
        showViewPage: action.actionType === "view",
      };

    case types.QUEUES_VALIDATION_ERROR:
      return { ...state, validation_error: action.validation_error };

    case types.QUEUES_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        queueRecord: null,
        formState: {},
        validation_error: null,
      };

    case types.HIDE_QUEUES_FIELD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key]) {
        const new_validation_error = { ...state.validation_error };
        delete new_validation_error[action.feild_key];
        return { ...state, validation_error: new_validation_error };
      }
      return state;

    default:
      return state;
  }
};

export default QueueReducer;
